module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Bullet-list-934d5e8198025b3ffb20e0e24f343bf9.svg";